import { render, staticRenderFns } from "./SlideTextLeftImageRight.vue?vue&type=template&id=bd495ef0&scoped=true&"
import script from "./SlideTextLeftImageRight.vue?vue&type=script&lang=ts&"
export * from "./SlideTextLeftImageRight.vue?vue&type=script&lang=ts&"
import style0 from "./SlideTextLeftImageRight.vue?vue&type=style&index=0&id=bd495ef0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd495ef0",
  null
  
)

export default component.exports